var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconForest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 25,
    viewBox: "0 0 15 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.10576 11.2356C0.525063 12.199 2.47686 14.4468 3.52535 15.4503H6.42894V24H8.24363C8.36461 21.1501 8.87272 15.4503 9.93734 15.4503C11.2681 15.4503 13.3248 15.4503 13.9297 12.801C14.5345 10.1518 11.0261 7.74346 11.5101 5.33508C11.994 2.9267 9.69538 1 6.42894 1C3.1625 1 3.52535 2.56544 3.52535 4.01047C3.52535 5.4555 1.83164 10.0314 1.10576 11.2356Z",
    fill: "#40C900",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconForest);
export default __webpack_public_path__ + "static/media/icon-forest.a2d57889c754a327755572e025ee3595.svg";
export { ForwardRef as ReactComponent };